<template>
 <footer class="footer">
        <div class="container">
            <div class="footer-content">
                <div class="footer-left-content">
                    <div class="footer-logo">
                        <img  class="footer-logo-img" src="@/assets/images/vn_logo2.png">
                        </div>
                    <div class="contact-us">{{$t('footer.contact')}}</div>
                    <!-- <div class="social-icons">
                        <img class="social-icon" @click="openSocialLink('https://x.com/vn_dropshipping')" src="@/assets/images/x.png">
                        <img class="social-icon" @click="openSocialLink('https://www.facebook.com/profile.php?id=61579837934254')" src="@/assets/images/facebook.png">
                        <img class="social-icon" @click="openSocialLink('https://www.tiktok.com/@voguenomadofficial')" src="@/assets/images/tiktok.png">
                        <img class="social-icon" @click="openSocialLink('https://www.youtube.com/@vn_dropshipping')" src="@/assets/images/youtube.png">
                        <img class="social-icon" @click="openSocialLink('https://www.instagram.com/vn_dropshipping')" src="@/assets/images/ins.png">
                    </div> -->
                    <!-- <p class="footer-email">{{$t('footer.email')}}</p> -->
                    <!-- <div class="footer-divider"></div> -->
                </div>
                <div class="footer-divider"></div>
                    <nav class="footer-nav">
                        <div class="footer-group">
                            <a href="javascript:void(0)">{{$t('footer.company')}}</a>
                          <router-link to="/about-us" class="second-nav">{{ $t('footer.about')}}</router-link>
                          <router-link to="/shipping-policy" class="second-nav">{{ $t('footer.freight_policy')}}</router-link>
                          <router-link to="/private-policy" class="second-nav">{{ $t('footer.privacy_policy')}}</router-link>
                          <router-link to="/terms-conditions" class="second-nav">{{ $t('footer.service_bar')}}</router-link>
                          <router-link to="/refund-policy" class="second-nav">{{ $t('footer.return_policy')}}</router-link>
                        </div>

                        <div class="footer-group">
                            <a href="javascript:void(0)">{{$t('footer.support')}}</a>
                          <router-link to="/faq" class="second-nav" >{{$t('footer.question')}}</router-link>
                          <!-- <router-link to="/blog" class="second-nav" >{{$t('footer.blog')}}</router-link> -->
                        </div>

                        <div class="footer-group">
                            <a href="javascript:void(0)">{{$t('footer.contact_information')}}</a>
                            <!-- <div class="footer-content-icon-content"><img class="footer-content-icon" src="@/assets/images/address_icon.png"><a href="#" class="has-icon" v-html="$t('footer.company_address')"></a></div>
                            <div class="footer-content-icon-content"><img class="footer-content-icon" src="@/assets/images/phone_icon.png"> <a href="#" class="has-icon">{{$t('footer.company_contact')}}</a></div>
                            <div class="footer-content-icon-content"><img class="footer-content-icon" src="@/assets/images/mail_icon.png"><a href="#" class="has-icon">{{$t('footer.company_email')}}</a></div> -->
                            <div class="footer-content-icon-content"><img class="footer-content-icon" src="@/assets/images/address_icon.png"><a class="has-icon" v-html="$t('footer.company_address')"></a></div>
                            <div class="footer-content-icon-content"><img class="footer-content-icon" src="@/assets/images/phone_icon.png"> <a class="has-icon">{{$t('footer.company_contact')}}</a></div>
                            <div class="footer-content-icon-content"><div class="footer-content-icon"></div><a class="has-icon">{{$t('footer.company_contact1')}}</a></div>
                            <div class="footer-content-icon-content"><img class="footer-content-icon" src="@/assets/images/mail_icon.png"><a class="has-icon">{{$t('footer.company_email')}}</a></div>
                        </div>
                    </nav>
            </div>
            <div class="copyright">
                <p>{{$t('footer.copyright')}}</p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  mounted() {
    const unwatch = this.$watch(
      () => this.$route,
      () => {
        window.scrollTo(0, 0)
      }
    )
    this.$once('hook:beforeDestroy', () => {
      unwatch()
    })
  }
}
</script>

<style>
.container {
  max-width: 100rem;
  margin: 0 auto;
  padding: 0 2rem;
}
/* Footer */
.footer {
    background: #16182C;
    color: white;
    padding: 3rem 0 1rem;
}

 .footer-content {
     display: grid;
     grid-template-columns: auto 1fr;
     gap: 10.8rem;
     margin-bottom: 2rem;
     align-items: center;
 }

 .footer-logo {
     display: flex;
     align-items: center;
     gap: 0.5rem;
     margin-bottom: 1rem;
 }

 .footer-logo-img {
    width: 220px;
    height:66px;
}

 .social-icons {
     display: flex;
     gap: 1rem;
     margin: 1rem 0;
 }
 .notes-info {
   opacity: 1;
   font-size: 1.2rem;
   font-weight: bold;
   color: #000000;
 }

 .footer-left-content {
     max-width: 20rem;
     flex-shrink: 0;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: flex-start;
 }

.notes-info-2 {
  opacity: 1;
  font-size: 1rem;
  font-weight: bold;
  color: #000000;
}

 .contact-us {
    font-size: 0.875rem;
    max-width: 18.4rem;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.5);
    margin: 1rem 0 0 0;
    opacity: 0.8;
    margin-top: 0.75rem;
    text-indent: 2em;
}



 .social-icon {
     width: 2.5rem;
     height: 2.5rem;
     background: #555;
     border-radius: 50%;
     display: flex;
     align-items: center;
     justify-content: center;
     cursor: pointer;
     margin-top: 2.6rem;
     transition: background 0.3s;
 }

 .social-icon:hover {
     background: #64B800;
 }

 .footer-nav {
     display: flex;
     gap: 4.5rem;
     justify-content: space-around;
     margin-bottom: 1rem;
     flex-wrap: nowrap !important;
     align-items: flex-start;
     margin-top: 1rem;
 }

 .footer-nav a {
     color: white;
     text-decoration: none;
     transition: color 0.3s;
     font-size: 0.875rem;
     font-weight: normal;
     opacity: 0.6;
     margin-bottom: 0.6rem;
     line-height: 1.4;
 }

 .footer-nav a:hover {
     color: #64B800;
 }

.shipping-import-text {
  opacity: 1;
  font-size: 1rem;
  font-weight: bold;
  color: #64B800;
  margin-top: 1rem;
}

 /* 有图片的链接样式 */
 .footer-nav a.has-icon {
     display: inline-block;
     vertical-align: top;
     margin-bottom: 1rem;
 }

 /* 没有图片的链接样式 */
 .footer-nav a:not(.has-icon) {
     display: block;
 }

 .footer-content-icon {
     width: 1rem;
     height: 1rem;
     flex-shrink: 0;
     vertical-align: top;
     display: inline-block;
     margin-right: 0.5rem;
     margin-top: 0.2rem;
 }

/* Icon + text row: keep icon fixed, allow text to wrap on next lines */
.footer-content-icon-content {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
}

.footer-content-icon-content a.has-icon {
    display: block;
    flex: 1;
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    word-break: break-all; /* fallback for extremely long tokens */
    line-height: 1.4;
}

.whvn-success-text {
  font-size: 1.5rem;
  font-weight: bold;
  color: #64B800
}

/* Desktop: constrain a single row width so long content wraps instead of pushing layout */
@media (min-width: 1025px) {
    .footer-content-icon-content {
        max-width: 24rem;
    }
}

 .second-nav {
     opacity: 0.5;
     font-size: 0.8rem;
     font-weight: normal;
     color: #FFFFFF;
 }

 .footer-divider {
    display: none;
 }

 .footer-group {
     display: flex;
     flex-direction: column;
     gap: 0.5rem;
     min-width: 0;
     /* flex: 1; */
 }

 /* 图片和链接在同一行的容器样式 */
 .footer-group .footer-content-icon + a.has-icon {
     margin-bottom: 0.5rem;
 }

 .footer-group a:first-child {
     font-weight: 500;
     margin-bottom: 0.25rem;
     font-size: 1.1rem;
     color: #ffffff;
     opacity: 1;

 }


 .copyright {
     text-align: center;
     padding-top: 2rem;
     /* border-top: 1px solid #555; */
     color: #999;
 }

/* Responsive */
/* 大屏幕适配 */
@media (max-width: 1920px) {
    .header-container {
        gap: 120px;
        padding: 0 1.8rem;
    }

    .nav {
        gap: 1.8rem;
    }
}

/* 中等屏幕适配 */
@media (max-width: 1600px) {
    .header-container {
        gap: 100px;
        padding: 0 1.6rem;
    }

    .nav {
        gap: 1.6rem;
    }
}

/* 小屏幕适配 */
@media (max-width: 1366px) {
    .header-container {
        gap: 80px;
        padding: 0 1.4rem;
    }

    .nav {
        gap: 1.4rem;
    }
}

/* 更小屏幕适配 */
@media (max-width: 1200px) {
    .header-container {
        gap: 60px;
        padding: 0 1.2rem;
    }

    .nav {
        gap: 1.2rem;
    }
}

/* 统一移动端样式：所有小于等于1024px的设备都使用移动端样式 */

 @media (max-width: 1024px) {

     /* 移动端适配 - 包括平板和手机 */
    .header {
        padding: 0;
        height: 3.5rem;
        z-index: 1001;
    }

    .header-container {
        gap: 0;
        padding: 0 1rem;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 3.5rem;
    }

    .logo {
        flex-shrink: 0;
        min-width: 120px;
        display: flex;
        align-items: center;
        height: 100%;
    }

    .logo img {
         height: 60px !important;
         width: 200px !important;
        object-fit: contain;
    }

     .nav {
         display: none;
     }

     /* 移动端导航下拉菜单 */
     .nav-dropdown {
         position: relative;
     }

     .nav-dropdown-menu {
         position: static;
         opacity: 1;
         visibility: visible;
         transform: none;
         box-shadow: none;
         background: transparent;
         padding: 0;
         margin-top: 0.5rem;
         margin-left: 1rem;
     }

     .nav-dropdown-menu a {
         padding: 0.5rem 0;
         font-size: 0.9rem;
         color: #666;
         border-bottom: 1px solid #eee;
     }

     .nav-dropdown-menu a:last-child {
         border-bottom: none;
     }

     .nav-dropdown-icon {
         display: none;
     }
}

@media (max-width: 1024px) {




     .footer-nav {
        display: flex;
        flex-wrap: nowrap;
         gap: 1rem;
     }

     .footer-group {
         gap: 0.5rem;
         width: 100%;
     }

     .second-nav {
         opacity: 0.5;
         font-size: 0.9rem;
         font-weight: normal;
         color: #FFFFFF;
     }

     .footer-group a:first-child {
         margin-bottom: 0.125rem;
     }



     @keyframes scrollRight {
         0% {
             transform: translateX(0);
         }

         100% {
             transform: translateX(calc(-6 * 120px - 5 * 1rem));
         }
     }
 }

/* Mobile styles */
@media (max-width: 1024px) {


     /* Footer适配 */
     .footer {
         padding: 2rem 1rem 0 1rem;
     }

     .footer-content {
         display: flex;
         flex-direction: column;
         align-items: center;
         text-align: center;
         gap: 2rem;
     }

     .footer-divider {
         display: block !important;
         width: 100%;
         max-width: 19.1rem;
         height: 1px;
         background-color: rgba(255, 255, 255, 0.3);
         margin: 1rem 0;
     }

     .footer-nav {
         display: flex !important;
         flex-direction: column;
         gap: 1.1rem;
         width: 100%;
         max-width: 19.1rem;
         align-items: flex-start;
         text-align: left;
     }

     .footer-nav a {
         text-align: left !important;
         margin-bottom: 0.3rem;
         font-size: 1.1rem;
         font-weight: normal;
        color: #ffffff;
        opacity: 0.6;
     }

     .footer-group a:first-child {
        font-size: 1.1rem;
        font-weight: 500;
        opacity: 1;
     }

     .footer-content>div:last-child {
         display: none !important;
     }

     .footer-logo {
         display: flex;
         justify-content: center;
         margin-bottom: 0;
     }


     .social-icons {
         display: flex;
         justify-content: center;
         gap: 1rem;
         margin: 1rem 0 0 0;
     }

    .social-icon {
        width: 3rem;
        height: 3rem;
    }

    .footer-email {
        font-size: 1rem;
        color: #FFFFFF;
        text-align: center;
        margin: 1rem 0 0 0;
    }

 .footer-divider {
     display: none;
 }

    .copyright {
        text-align: center;
        border-top: 1px solid rgba(255, 255, 255, 0.3) !important;
        margin: 1rem 0 !important;
        padding-top: 1rem !important;
        padding-bottom: 0 !important;
        color: #999;
    }

    /* 表格适配 */
    .delivery-table {
        width: 100%;
        font-size: 0.9rem;
        margin-bottom: 1rem;
    }

     .delivery-table td {
         padding: 0.5rem;
     }

    /* Tab按钮适配 */
    .tab-button {
        font-size: 1rem;
    }

     /* 防止水平滚动 */
     .image-grid-container {
         overflow: hidden;
     }

     .carousel-container {
         overflow: hidden;
     }

     .platform-logos {
         overflow: hidden;
     }

     .footer-left-content {
        margin:  0 auto;
     }
     .footer-logo {
        margin: 0 auto;
     }
     .contact-us {
        font-size: 1.1rem;
        font-weight: normal;
        color: #FFFFFF;
        text-align: left !important;
        opacity: 0.8;
        text-indent: 2em;
     }
     .footer-logo-img {
        width: 19.1rem;
        height: 5.75rem;
     }
     .footer-group {
        margin-bottom: 3.2rem;
     }

    /* 确保所有元素不超出屏幕宽度 */
    .section,
    .container,
    .container-2 {
        max-width: 100%;
        overflow-x: hidden;
    }
    .footer-content-icon-content {
        display: flex;
        align-items: flex-start;
    }

    html[lang="cn"] .hero-content span {
        font-size: 1.7rem;
        text-align: center;
    }
    /* English language specific styling for mobile */
    html[lang="en"] .hero-content span {
        font-size: 1.5rem;
        text-align: center;
    }

    html[lang="en"] .hero-content p {
        font-size: 0.8rem;
        text-align: center;
        margin-top: 1rem;
    }

    html[lang="cn"] .hero-content p {
        font-size: 1.4rem;
        text-align: center;
        margin-top: 1rem;
    }

    html[lang="en"] .hero-title2 {
        font-size: 1.3rem;
        text-align: center;
        margin-top: 1rem;
    }


    html[lang="en"] .section-title {
        font-size: 1.3rem;
    }

    html[lang="en"] .section-subtitle {
        font-size: 0.9rem;
    }

    html[lang="en"] .platform-section-title {
        font-size: 1.3rem;
    }

    html[lang="en"] .platform-section-subtitle {
        font-size: 0.9rem;
        margin-bottom: 1.5rem;
    }

    /* 英文版特殊布局调整 - 调整platform-logos位置避免重叠 */
    html[lang="en"] .platform-content > div:first-child > div:first-child {
        margin-bottom: 6rem;
    }

    html[lang="en"] .platform-content > div:first-child > div:last-child {
        margin-top: 6rem;
    }

    /* 英文版调整platform-logos位置 */
    html[lang="en"] .platform-content .platform-logos {
        top: 55%;
    }

    html[lang="en"] .delivery-title {
        font-size: 1.3rem;
    }

    html[lang="en"] .delivery-title-success {
        font-size: 1.3rem;
    }

    html[lang="en"] .step-title-text {
        font-size: 1.2rem;
    }

    html[lang="en"] .advantage-icon-title {
        font-size: 0.9rem;
    }

    html[lang="en"] .cta-title-text {
        font-size: 1.3rem;
    }

    html[lang="en"] .cta-right-content-item {
        font-size: 0.8rem;
    }

    html[lang="en"] .news-title {
        font-size: 0.9rem;
    }

    html[lang="en"] .company-intro p {
        font-size: 0.9rem;
    }

    html[lang="en"] .core-advantages .section-subtitle {
        font-size: 0.9rem;
    }

    html[lang="en"] .tab-button {
        font-size: 1.2rem;
    }

    html[lang="en"] .delivery-table {
        font-size: 0.8rem;
    }
    html[lang="en"]  .platform-buttons {
         flex-direction: column;
         gap: 1rem;
         align-items: center;
     }
  .shipping-import-text {
    opacity: 1;
    font-size: 1rem;
    font-weight: bold;
    color: #64B800;
    margin-top: 1rem;
  }

}
</style>
